var React = require('react');

function PhoneInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.4578 0H1.54222C0.690043 0 0 0.720507 0 1.60135V20.3987C0 21.2835 0.690043 22 1.54222 22H10.4578C11.31 22 12 21.2835 12 20.3987V1.60135C12 0.720507 11.31 0 10.4578 0ZM3.80055 0.975039H8.19945C8.31237 0.975039 8.40309 1.1474 8.40309 1.35884C8.40309 1.57429 8.31237 1.74665 8.19945 1.74665H3.80055C3.68667 1.74665 3.59981 1.57429 3.59981 1.35884C3.59981 1.1474 3.68667 0.975039 3.80055 0.975039ZM6.00193 20.4177C5.45858 20.4177 5.01367 19.9597 5.01367 19.3966C5.01367 18.8324 5.45858 18.3744 6.00193 18.3744C6.54045 18.3744 6.9815 18.8324 6.9815 19.3966C6.9815 19.9597 6.54045 20.4177 6.00193 20.4177ZM1.15715 16.9144H10.8419V2.70566H1.15715V16.9144Z","fill":"#1999D6"}));
}

PhoneInline.defaultProps = {"width":"12","height":"22","viewBox":"0 0 12 22","fill":"none"};

module.exports = PhoneInline;

PhoneInline.default = PhoneInline;
